module.exports = __webpack_public_path__ + "static/media/02_pre-enrollment-application.80e993a8.svg";